import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { IconButton, Toolbar, AppBar } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Spinner from "../spinner";
import EmptyView from "../empty-view";
import "./page.scss";

import { useSelector, useDispatch } from "react-redux";
import selectors from "selectors";
import { setNewNotificationsAmount } from "reducers/notifications";
import { useHistory } from "react-router-dom";
import { fetchNotificationCountBeforeDate } from "actions/notifications";
import Logo from "assets/images/MySleepCoach_WellSky_Logo.png";
import ProfileIcon from "assets/images/UserProfileIcon.svg";
import NotificationsIcon from "assets/images/NotificationsIcon.svg";

import NotificationsModal from "../../notifications/notifications-modal";

// AppBar component for the top navigation bar
export const AppBarHeader = ({ onMenuClick, mobileMenuOpen }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const user_details = useSelector(selectors.getUserDetails);
  const newNotificationsAmount = useSelector(
    selectors.getNewNotificationsAmount
  );
  const notificationsLastBrowse = useSelector(
    selectors.getNotificationsLastBrowse
  );

  const [notificationsOpen, setNotificationsOpen] = React.useState(false);

  const setNotificationsAmount = async () => {
    const result = await dispatch(
      fetchNotificationCountBeforeDate(notificationsLastBrowse)
    );
    dispatch(setNewNotificationsAmount(result));
  };

  useEffect(() => {
    setNotificationsAmount();
  }, [notificationsLastBrowse]);

  return (
    <AppBar className="appBar">
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label={mobileMenuOpen ? "Close navigation menu" : "Open navigation menu"}
          aria-expanded={mobileMenuOpen}
          aria-controls="mobile-navigation-drawer"
          edge="start"
          onClick={(e) => {
            if (onMenuClick) {
              onMenuClick(e);
            }
          }}
          sx={{
            display: { xs: 'flex', sm: 'none' },
            position: 'absolute',
            left: '12px',
            top: '35px',
            padding: '8px',
            zIndex: 10,
            cursor: 'pointer'
          }}
        >
          <MenuIcon sx={{ color: '#4db8ff' }} />
        </IconButton>
        <div className="app-bar-logo">
          <img src={Logo} alt=""></img>
        </div>
        <div className="notificationsAndNameContainer">
          <IconButton
            id="notifications-button"
            className="notificationsIconContainer"
            onClick={() => setNotificationsOpen(!notificationsOpen)}
            aria-label="Notifications"
            aria-haspopup="dialog"
            aria-expanded={notificationsOpen}
            aria-controls="notifications-dialog"
          >
            <img src={NotificationsIcon} alt=""></img>
            {newNotificationsAmount > 0 && (
              <div className="newNotificationsAmountContainer">
                {newNotificationsAmount}
              </div>
            )}
          </IconButton>
          <NotificationsModal
            isOpen={notificationsOpen}
            onClose={() => setNotificationsOpen(false)}
          />

          <div className="usernameAndMenuContainer">
            <IconButton
              onClick={() => {
                history.push("/profile");
              }}
              aria-label="Profile"
            >
              <img src={ProfileIcon} alt="" />
            </IconButton>
            <div className="userName">{user_details.name}</div>
          </div>
        </div>
      </Toolbar>
    </AppBar>
  );
};

AppBarHeader.propTypes = {
  onMenuClick: PropTypes.func,
  mobileMenuOpen: PropTypes.bool
};

// Page Header component for page titles (not the main AppBar)
export const Header = ({ title, goBack, children }) => {
  return null; // This component doesn't render anything - pages don't need separate headers
};

Header.propTypes = {
  title: PropTypes.string,
  goBack: PropTypes.bool,
  children: PropTypes.node
};

export const Container = ({ children, ...rest }) => (
  <div className="page" {...rest}>
    {children}
  </div>
);

Container.propTypes = {
  children: PropTypes.node
};
export const Content = ({
  isFetching,
  isEmpty,
  emptyMessage,
  children,
  styles
}) => {
  return isFetching ? (
    <div className="page-content">
      <Spinner size={50} />
    </div>
  ) : isEmpty ? (
    <EmptyView message={emptyMessage} />
  ) : (
    <div
      style={
        styles
          ? { display: "flex", flexDirection: "column", flex: 1, ...styles }
          : { display: "flex", flexDirection: "column", flex: 1 }
      }
    >
      {children}
    </div>
  );
};

Content.propTypes = {
  isFetching: PropTypes.bool,
  isEmpty: PropTypes.bool,
  emptyMessage: PropTypes.string,
  children: PropTypes.node,
  styles: PropTypes.object
};

export default { Container, Content, Header };
